export default __webpack_public_path__ + "static/media/mobile_banner_travel.f8bb9f6f.jpg";